import { render, staticRenderFns } from "./okx-ad-dialog.vue?vue&type=template&id=37036b45&scoped=true&"
import script from "./okx-ad-dialog.vue?vue&type=script&lang=js&"
export * from "./okx-ad-dialog.vue?vue&type=script&lang=js&"
import style0 from "./okx-ad-dialog.vue?vue&type=style&index=0&id=37036b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37036b45",
  null
  
)

export default component.exports